// --------------------------------------------------------
// LIST HEADER - ListHeader
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React from 'react'
import { CompanyListHeaderContainer, CompanyListHeaderTable, CompanyListHeaderTableData } from '../../pages/company/CompanyList.styled'
import { Text } from '../UI/generalLayout/Layout.styled';
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// LIST HEADER INTERFACE
// --------------------------------------------------------

interface IListHeader{
    fields: any[];
}
/**
/**
 * A component that renders a List Header.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const ListHeader = ({fields}:IListHeader) => {
  // --------------------------------------------------------
  // LIST HEADER PRIVATE DECLARATIONS
  // --------------------------------------------------------
  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
        <CompanyListHeaderContainer>
            <CompanyListHeaderTable>
                <tbody>
                    <tr>
                        {fields.map((field, index)=>{
                            return (
                            <CompanyListHeaderTableData key={index} style={{textAlign: field.align !== null? field.align : ''}} width={field.width}>
                                <Text bold>{field.name}</Text>
                            </CompanyListHeaderTableData>)
                        })}
                    </tr>
                </tbody>
            </CompanyListHeaderTable>
        </CompanyListHeaderContainer>
    </>
  )
  // --------------------------------------------------------
}

export default ListHeader
